import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerInstagramDashboardOverview.graphql';
import { Query, QueryinfluencerInstagramDashboardOverviewArgs } from '../../__generated__/globalTypes';

export const useInfluencerInstagramDashboardOverviewQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerInstagramDashboardOverviewArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerInstagramDashboardOverviewArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerInstagramDashboardOverviewLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerInstagramDashboardOverviewArgs>
): QueryResult<Query, QueryinfluencerInstagramDashboardOverviewArgs> & {
  getInfluencerInstagramDashboardOverview: LazyQueryExecFunction<Query, QueryinfluencerInstagramDashboardOverviewArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerInstagramDashboardOverview, result] = useLazyQuery<
    Query,
    QueryinfluencerInstagramDashboardOverviewArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerInstagramDashboardOverview, ...result };
};

export const useInfluencerInstagramDashboardOverviewPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerInstagramDashboardOverview = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerInstagramDashboardOverviewArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerInstagramDashboardOverviewArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerInstagramDashboardOverview };
};
// Suspense Query Hooks
export const useInfluencerInstagramDashboardOverviewSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerInstagramDashboardOverviewArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerInstagramDashboardOverviewArgs>(QUERY, {
    ...options
  });

  return result;
};
